module.exports = __webpack_public_path__ + "img/15053254000145.a580fe31.png";